import React from 'react';

import DuplicatesPage from '../components/DuplicatesPage';

const DuplicatesApp = (props) => (
  <DuplicatesPage {...props} />
);

export default DuplicatesApp;
